module.exports = __webpack_public_path__ + "static/img/icon7.328fe172.gif";